import { htmlToDOM } from "html-react-parser";

// Keep the API's formatted amounts; only arrange the known wholesale template.
export const getWholesalePriceSummary = (html) => {
    const readText = (node) => {
        if (node.type === "text") return node.data;
        if (node.type !== "tag") return "";
        return (node.children ?? []).map(readText).join(" ");
    };
    const text = htmlToDOM(html).map(readText).join(" ").replace(/\s+/g, " ").trim();
    const match = text.match(/^VP\s+cena\s*:\s*(\d[\d\s.,]*\s+[A-Z]{3})\s*Rabat\s*:\s*([\d.,]+\s*%)\s*Neto\s+cena\s+sa\s+rabatom\s*:\s*(\d[\d\s.,]*\s+[A-Z]{3})$/i);
    return match ? { wholesale: match[1].trim(), rebate: match[2].trim(), net: match[3].trim() } : null;
};
